// Login.jsx
import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { redirect_path } from '../config/config';
import { isLoggedIn } from '../config/token';
import LoginForm from '../components/Login/LoginForm';

const Login = () => {
  const [successLogIn, setLoginSuccess] = useState(false);
  
  if (isLoggedIn() || successLogIn) return <Redirect to={redirect_path} />

  return <LoginForm setLoginSuccess={setLoginSuccess} />
}

export default Login